import { memo } from 'react';
import { Box, Image, Text } from '@betty/moonlight';
import { REWARD_IMAGE_SIZE, REWARD_IMAGES } from './BonusInfo.content';
import { BonusInfoProps } from './BonusInfo.types';
import BonusImage from '../BonusImage/BonusImage';
import BonusProgress from '../BonusProgress/BonusProgress';
import RewardsText from '../RewardsText/RewardsText';
import BonusInfoSkeleton from './BonusInfoSkeleton/BonusInfoSkeleton';

function BonusInfo({
  promos,
  textKey,
  textNS,
  progress,
  imageSize,
  horizontal,
  ...rest
}: BonusInfoProps) {
  if (!promos.length) {
    return (
      <BonusInfoSkeleton
        textKey={textKey}
        progress={progress}
        imageSize={imageSize}
        horizontal={horizontal}
        {...rest}
      />
    );
  }

  return (
    <Box flexDirection={horizontal ? 'row' : 'column'} {...rest}>
      <Box flexDirection="row" centerContent>
        {promos.map(({ promotionId, rewards, miniImageUrl }, index) => {
          const { rewardTarget } = rewards[0];
          const imageName =
            rewards.length > 1 ? undefined : REWARD_IMAGES[rewardTarget];

          return (
            <Box
              key={promotionId}
              transform={
                !horizontal && promos.length > 1 ? 'translateX(8px)' : 'none'
              }
              flexDirection="row"
              alignItems="center"
            >
              <BonusImage
                name={imageName}
                width={imageSize}
                height={imageSize}
                miniImageUrl={miniImageUrl}
                transform={{
                  mobile: index > 0 ? 'translateX(-16px)' : 'none',
                  tablet: 'none',
                  desktop: 'none',
                }}
              />
              {index !== promos.length - 1 ? (
                <Text
                  variant="body-l-semi"
                  gradient="darkSurfaceAccent"
                  display={{
                    mobile: 'none',
                    tablet: 'flex',
                    desktop: 'flex',
                  }}
                  marginHorizontal="space-100"
                >
                  +
                </Text>
              ) : null}
              {index > 0 && index === promos.length - 1 ? (
                <Image
                  name="onboarding.reward"
                  position="absolute"
                  top="space-0"
                  right="space-0"
                  width={REWARD_IMAGE_SIZE}
                  height={REWARD_IMAGE_SIZE}
                  transform={{
                    mobile: 'translate(-10px, -6px)',
                    tablet: 'translate(6px, -6px)',
                    desktop: 'translate(6px, -6px)',
                  }}
                />
              ) : null}
            </Box>
          );
        })}
      </Box>
      <Box
        flex={horizontal ? 1 : undefined}
        gap="space-100"
        centerContent={!horizontal}
      >
        {textKey && (
          <Text
            variant="body-s-semi"
            locKey={textKey}
            locNS={textNS}
            color="darkSurfacePrimary"
          />
        )}
        <RewardsText promos={promos} />
        {progress !== undefined ? (
          <BonusProgress progress={progress} paddingTop="space-100" />
        ) : null}
      </Box>
    </Box>
  );
}

export default memo(BonusInfo);
